import React from "react";

import DonatedPill from "./DonatedPill";
import MarkAsDonatedPill from "./MarkAsDonatedPill";

export default function PaymentPill({
  name,
  additionalNameID,
  unpaidSlotsCount,
  isItemType,
  amount,
  date,
  status,
  markedPaidName,
  userName,
  payerName,
  payerUserID,
  style,
  isHovering,
  parentComponent, // "HouseholdMember" | "AdditionalName" | "Respondent"
  isSuggestedDonation,
  signupItemID,
}) {
  const donationPillProps = {
    amount: amount,
    date: date,
    status: status,
    markedPaidName: markedPaidName,
    payerUserID: payerUserID,
    additionalNameID: additionalNameID,
    userName: userName,
    payerName: payerName,
    isSuggestedDonation: isSuggestedDonation,
    signupItemID,
    style: style,
  };
  /**
   * HOUSEHOLD MEMBER
   */
  if (parentComponent === "HouseholdMember") {
    if (
      (isItemType && unpaidSlotsCount > 0) ||
      (status !== "Paid" && status !== "MarkedAsPaid")
    )
      return (
        <MarkAsDonatedPill
          name={name}
          additionalNameID={additionalNameID}
          unpaidSlotsCount={unpaidSlotsCount}
          isItemType={isItemType}
          signupItemID={signupItemID}
          style={style}
          isHovering={isHovering}
        />
      );

    return <DonatedPill {...donationPillProps} />;
  }

  /**
   * ADDITIONAL NAME
   */
  if (parentComponent === "AdditionalName") {
    if (status === "Paid" || status === "MarkedAsPaid") {
      return <DonatedPill {...donationPillProps} />;
    }

    return (
      <MarkAsDonatedPill
        name={name}
        additionalNameID={additionalNameID}
        signupItemID={signupItemID}
        style={style}
        isHovering={isHovering}
      />
    );
  }

  /**
   * RESPONDENT
   */
  if (parentComponent === "Respondent") {
    if (status !== "Paid" && status !== "MarkedAsPaid") {
      return (
        <MarkAsDonatedPill
          name={name}
          additionalNameID={additionalNameID}
          unpaidSlotsCount={unpaidSlotsCount}
          signupItemID={signupItemID}
          isItemType={isItemType}
          style={style}
          isHovering={isHovering}
        />
      );
    }

    return <DonatedPill {...donationPillProps} />;
  }

  return null;
}
